<script setup lang="ts">
    import { useI18n } from 'vue-i18n';
    import { EventFeedType } from '@/constants';
    import { useAppStore } from '@/stores/app';

    const { t } = useI18n();

    const { id = '0' } = defineProps<{
        id: string;
    }>();

    const appStore = useAppStore();
    const bettingData = appStore.betFeedData[id];

    function timeoutToText() {
        const isLive = appStore.betFeedData[id].eventFeedType === EventFeedType.Live;

        if (isLive) {
            if (Number(bettingData.timeout) < 60) {
                return bettingData.timeout + ' ' + t('betDialogConfirm.seconds');
            } else if (bettingData.timeout === 60) {
                return ' 1' + t('betDialogConfirm.minute');
            } else {
                return Number(bettingData.timeout) / 60 + ' ' + t('betDialogConfirm.minutes');
            }
        } else {
            if (Number(bettingData.timeout) < 60) {
                return bettingData.timeout + ' ' + t('betDialogConfirm.seconds');
            } else if (bettingData.timeout === 60) {
                return ' 1' + t('betDialogConfirm.minute');
            } else if (Number(bettingData.timeout) < 3600) {
                return Number(bettingData.timeout) / 60 + ' ' + t('betDialogConfirm.minutes');
            } else if (bettingData.timeout === 3600) {
                return bettingData.timeout / 3600 + ' ' + t('betDialogConfirm.hour');
            } else {
                return Number(bettingData.timeout) / 3600 + ' ' + t('betDialogConfirm.hours');
            }
        }
    }
</script>
<template>
    <ul>
        <li v-if="bettingData.timeout === 0" class="py-1" v-html="t('betDialogConfirm.timeoutKickOffText', { bet: t('betDialogConfirm.bet', { count: bettingData.isTopUps ? 0 : 1 }) })"></li>
        <li v-else-if="bettingData.timeout === null" class="py-1" v-html="t('betDialogConfirm.noTimeoutText', { bet: t('betDialogConfirm.bet', { count: bettingData.isTopUps ? 0 : 1 }) })"></li>
        <li v-else class="py-1" v-html="t('betDialogConfirm.timeoutText', { bet: t('betDialogConfirm.bet', { count: bettingData.isTopUps ? 0 : 1 }), timeout: timeoutToText() })"></li>
        <li v-if="bettingData.isTopUps" class="py-1" v-html="t('betDialogConfirm.isTopUpsText')"></li>
    </ul>
</template>
